import React from 'react'
import { CFooter } from '@coreui/react'
import moment from 'moment'

const AppFooter = () => {
  const year = moment(new Date()).format('YYYY')

  return (
    <CFooter>
      <div>
        <span className="ms-1">&copy; {year} Mediacartz.</span>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
